module.exports = __webpack_public_path__ + "img/play.2371ea09.svg";